import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { configureStore } from './store'
import App from './routes/App'
import './lib/reactifyCss'

const store = configureStore()

const MainApp = () => (
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
)

ReactDOM.render(<MainApp />, document.getElementById('root'))
